import React, { Component } from 'react'
import StagesManager from '../../../components/StagesManager';
import StartQuiz from './StartQuiz';
import Quiz from './Quiz';
import EndQuiz from './EndQuiz';
import HttpServices from '../../../utils/Http.services';
import UserRecent from './UserRecent';
import Header from '../../../components/header/Header';

class QuizPage extends Component {

    state = {
        inquiry: { time: 100 },
        id: '',
        backbtn: true,
        bg: 'linear-gradient(90deg, #6E9318, #96C723)',
        bg2: 'rgba(37, 91, 0, 0.1)',
        showToolbar: true,
        headerConfig: {
            showToolbar: false, showSettings: false, showSettings: false
        },
        answerSheetView:false,
    }
    mount = true
    componentDidMount() {
        // if (this.setHeader) {
        // }
        if (this.props.defaultHeaderConfig) {
            this.setState({ headerConfig: this.props.defaultHeaderConfig })
        }
        this.setState({ headerConfig: this.state.headerConfig })
        if (this.props.windowData.path && this.props.windowData?.path[3]) {
            this.getRecord(this.props.windowData?.path[3]);
            this.getCurrentInquiry(this.props.windowData?.path[3]);
            this.stageManager.changeStage("startQuiz");
        } else {
            this.stageManager.changeStage("start");
        }
        this.getRecords()
    }

    componentDidUpdate() {

        if (this.props.windowData.path && this.props.windowData?.path[3] && this.props.windowData?.path[3] != this.state.id && this.mount) {
            this.mount = false
            this.getRecord(this.props.windowData?.path[3]);
            this.getCurrentInquiry(this.props.windowData?.path[3]);
            this.stageManager.changeStage("startQuiz");
        }
    }

    setHeader = (key, value) => {

        // console.log("SETTTT")
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    getRecords = () => {
        let data = {}
        data.applet = this.props.applet._id
        data.hub = this.props.user.info._id
        // console.log('aaaaaaaa', this.props.frames)
        data.frame = this.props.frameId // ped
        // data.frame = '669919543d9d301b11b6a684' //parna

        data.features = 'Inquiry'
        // console.log('thissssproo',this.props)
        HttpServices.request('getRecords', data, ((fetchResult, fetchError) => {
            // console.log(data,'fetchError',fetchError)
            if (fetchError) {
                return
            }
            // console.log('getre',fetchResult.info)
            this.setState({ data: fetchResult.info })
        }))
    }

    getRecord = (id) => {
        let data = {}
        data._id = id
        HttpServices.request('getRecord', data, ((fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            this.setState({ id, quiz: fetchResult.info }, () => {
                this.mount = true
            })
        }))
    }

    changeBackbtn = (check) => {
        this.setState({ backbtn: check }, () => {
        })
    }

    retake = () => {
        if (this.props.windowData.path && this.props.windowData?.path[3]) {
            this.getCurrentInquiry(this.props.windowData?.path[3])
            this.stageManager.changeStage('startQuiz')
        } else {
            this.stageManager.changeStage('start')
        }
    }

    getCurrentInquiry = (id) => {
        // console.log('getCurrentInquiry11', id)
        let data = {}
        data.inquiry = id
        data.applet = this.props.applet._id
        HttpServices.request('getCurrentInquiry', data, (fetchResult, fetchError) => {
            this.setState({ isLoading: false })
            if (fetchError) {
                return
            }
            // console.log('fetchResult', fetchError)
            this.setState({ current: fetchResult.info?.current, allQuizes: fetchResult.info?.allQuizes })
        })
    }


    startQuiz = () => {
        this.stageManager.changeStage('quiz')
        // this.setState({ current: null })
    }

    viewAnswerSheet = () => {
        this.setState({answerSheetView:true},()=>{

            this.stageManager?.changeStage('quiz')
        })
    }
    endInquirie = () => {
        this.stageManager?.changeStage('endpage')
    }

    endInquiry = () => {
        HttpServices.request('endInquiry', { inquiry: this.props.windowData?.path[3], applet: this.props.applet._id }, ((fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            // if (!this.state.current) {
                this.setState({ current: fetchResult.info,allQuizes:fetchResult.allQuizes??[] },()=>{

                    // }
                    this.endInquirie()
                })
        }))
    }
    answerSheetViewed = () => {
        this.setState({cantRetake:true})
        HttpServices.request('answerSheetViewed', { inquiry: this.props.windowData?.path[3], applet: this.props.applet._id }, ((fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            // if (!this.state.current) {
                this.setState({ current: fetchResult.info },()=>{

                    this.viewAnswerSheet()
                })
            // }
        }))
    }

    // changePage = (stage) => {
    //     this.stageManager.changeStage(stage)
    // }

    changeQuizPage = (page) => {
        // getCurrentInquiry
        let path;
        if (page) {
            if (Array.isArray(page)) {
                path = page;
            } else {
                path = [page?.key ?? page];
            }
        }
        this.props.changeWindowLink(path);
        // this.changePage('startQuiz')
    }

    backStage = () => {
        this.stageManager.lastStage((stage) => {
            let showToolbar = false
            let shouldHaveToolbar = ['start', 0]
            if (shouldHaveToolbar.includes(stage)) {
                showToolbar = true
            }
            let showBackBtn = true
            let shouldHaveBackBtn = ['start', 0]
            if (shouldHaveBackBtn.includes(stage)) {
                showBackBtn = false
            }
            this.setState({ showToolbar, showBackBtn })
        })
    }

    changePage = (stage) => {
        let showToolbar = false
        let shouldHaveToolbar = ['start',]
        if (shouldHaveToolbar.includes(stage)) {
            showToolbar = true
        }
        let showBackBtn = true
        let shouldHaveBackBtn = ['start',]
        if (shouldHaveBackBtn.includes(stage)) {
            showBackBtn = false
            this.setState({ data: {} })
        }
        this.stageManager.changeStage(stage)
        this.setState({ showToolbar, showBackBtn })
    }

    backToQuizPage = () => {
        this.stageManager.changeStage('start')
        // this.changePage('start')
        this.props.changeWindowLink([]);

    }

    render() {
        return (
            <div className='d-flex w-100 h-100 window-content-radius ' style={{ display: 'block', backgroundColor: '#fff' }}>
                <div className="w-100  h-100  window-content-radius d-flex flex-column " ref={el => this.pageContainer = el} style={{}} >
                    <div style={{ position: 'relative', top: 0 }}>
                        <Header ref={el => this.header = el} config={this.state.headerConfig} setHeader={this.setHeader} cart={this.state.cart} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} />
                    </div>
                    <StagesManager ref={el => this.stageManager = el} fast={true} height={'0px'} className={'flex-1'}  >
                        <UserRecent stage={0} stageName={'start'} backStage={this.backStage} changeBackbtn={this.changeBackbtn} initData={this.state.data} setData={this.setData} width={this.props.width}
                            pages={this.state.pages}
                            data={this.state.data}
                            user={this.props.user}
                            startQuiz={this.startQuiz}
                            getOneInquiry={this.getOneInquiry}
                            changeQuizPage={this.changeQuizPage}
                            endInquiry={this.endInquiry}
                            addNotif={this.addNotif}
                            variables={this.props.variables}
                            inquiry={this.state.inquiry}
                            questions={this.state.questions}
                            current={this.state.current}
                            height={this.props.height}
                            route={this.props.rootUrl}
                            applet={this.props.applet}
                            connection={this.props.connection}
                            setUser={this.props.setUser}
                            history={this.props.history}
                            location={this.props.location}
                            goToHub={this.props.goToHub}
                            changePage={this.changePage}
                            language={this.props.language}
                            colors={this.props.colors}
                            setHeader={this.setHeader}
                            backToQuizPage={this.backToQuizPage}
                        />
                        <StartQuiz stage={1} stageName={'startQuiz'} backStage={this.backStage} changeBackbtn={this.changeBackbtn} initData={this.state.data} setData={this.setData} width={this.props.width}
                            pages={this.state.pages}
                            quiz={this.state.quiz}
                            user={this.props.user}
                            startQuiz={this.startQuiz}
                            getOneInquiry={this.getOneInquiry}
                            endInquiry={this.endInquiry}
                            addNotif={this.addNotif}
                            variables={this.props.variables}
                            inquiry={this.state.inquiry}
                            questions={this.state.questions}
                            current={this.state.current}
                            allQuizes={this.state.allQuizes}
                            changePage={this.changePage}
                            changeQuizPage={this.changeQuizPage}
                            applet={this.props.applet}
                            language={this.props.language}
                            colors={this.props.colors}
                            setHeader={this.setHeader}
                            backToQuizPage={this.backToQuizPage}
                            windowData={this.props.windowData}
                        />
                        <Quiz stage={1} stageName={'quiz'} backStage={this.backStage} initData={this.state.data} setData={this.setData} width={this.props.width} height={this.props.height} data={this.props.data} changeWindow={this.props.changeWindow}
                            pages={this.state.pages}
                            user={this.props.user}
                            quiz={this.state.quiz}
                            changePage={this.changePage}
                            endInquiry={this.endInquiry}
                            endInquirie={this.endInquirie}
                            addNotif={this.addNotif}
                            variables={this.props.variables}
                            inquiry={this.state.inquiry}
                            questions={this.state.questions}
                            current={this.state.current}
                            allQuizes={this.state.allQuizes}
                            applet={this.props.applet}
                            language={this.props.language}
                            colors={this.props.colors}
                            setHeader={this.setHeader}
                            backToQuizPage={this.backToQuizPage}
                            answerSheetView={this.state.answerSheetView}
                        />
                        
                        <EndQuiz stage={1} stageName={'endpage'} backStage={this.backStage} initData={this.state.data} setData={this.setData} width={this.props.width} height={this.props.height} data={this.props.data} changeWindow={this.props.changeWindow}
                            pages={this.state.pages}
                            user={this.props.user}
                            quiz={this.state.quiz}
                            changePage={this.changePage}
                            endInquiry={this.endInquiry}
                            answerSheetViewed={this.answerSheetViewed}
                            allQuizes={this.state.allQuizes}
                            retake={this.retake}
                            addNotif={this.addNotif}
                            variables={this.props.variables}
                            inquiry={this.state.inquiry}
                            questions={this.state.questions}
                            current={this.state.current}
                            applet={this.props.applet}
                            language={this.props.language}
                            colors={this.props.colors}
                            setHeader={this.setHeader}
                            backToQuizPage={this.backToQuizPage}
                        />
                    </StagesManager>
                </div>
            </div>
        )
    }
}

export default QuizPage